import React from 'react';
import { ButtonContent, StyledButton } from './styles';
import { Condition } from '../../condition';
import { Image } from '../../image';
import { Box } from '../../box';

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?:
    | 'primary'
    | 'secondary'
    | 'success'
    | 'pink'
    | 'green'
    | 'greenBlueGradient'
    | 'orange'
    | 'blue-auth'
    | 'yellow'
    | 'yellowGradient'
    | 'blue'
    | 'danger'
    | 'transparent'
    | 'notify'
    | 'bonusBlue'
    | 'bonusYellow'
    | 'black'
    | 'midnightPurple'
    | 'gray'
    | 'orangeGradient'
    | 'wishlist'
    | 'grayBlack';
  icon?: JSX.Element;
  isLoading?: boolean;
  children?: React.ReactNode;
  fill?: boolean;
  forIcon?: boolean;
}

const Button: React.FC<ButtonProps> = ({
  children,
  variant = 'primary',
  icon,
  isLoading,
  fill,
  forIcon = false,
  ...rest
}) => {
  return (
    <StyledButton $fill={fill} $variant={variant} {...rest}>
      <Condition match={!isLoading}>
        <ButtonContent $forIcon={forIcon}>
          {icon && icon}
          {children}
        </ButtonContent>
      </Condition>
      <Condition match={isLoading}>
        <ButtonContent>
          <Box $position="absolute">
            <Image
              width={24}
              height={24}
              src="/images/icons/element-loader.svg"
            />
          </Box>
        </ButtonContent>
      </Condition>
    </StyledButton>
  );
};

export { Button };
